import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { UploadDeliveryLayout } from '~/features/integrations/components/upload-delivery/upload-delivery-layout';
import { requireSystemAdmin } from '~/utils/guards';

/**
 * Standalone upload-delivery flow (`/upload-delivery/*`) — the file-selection wizard for
 * both the single-file and multi-file group paths.
 *
 * Lives outside `/integrations` on purpose: the Integrations tab bar let an operator navigate
 * away mid-upload and lose a staged file. The deliveries **list** stays on its Integrations
 * tab (`/integrations/upload-delivery`); only the creation flow is here.
 *
 * Super-admin, matching the Integrations tab it is reached from. The guard sits on the layout
 * so every child inherits it rather than repeating it.
 */
const searchSchema = z.object({ sc: z.string().optional() });

export const Route = createFileRoute('/_authenticated/_tenant/upload-delivery')({
  validateSearch: searchSchema,
  beforeLoad: requireSystemAdmin(),
  component: UploadDeliveryLayout,
});
